// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Fsession-protocol%2Fsrc%2Fmessages.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { AnnotationResultStateUpdate, IAnnotationActivationMessage, IAnnotationActivationResponse, IAnnotationReleaseMessage, IAnnotationReleaseResponse, IAnnotationResultStateMessage, IAnnotationResultsMessage, ICacheDumpRequestMessage, ICacheDumpRequestResponse, IErrorResponse, IMessage, IMicroSyncMessage, IResponse, ISessionCloseMessage, ISessionDeleteMessage, ISessionInitMessage, ISessionInitResponse, ISyncMessage, ISyncResponse, ITimeoutErrorResponse, ITokenProvisionMessage, ITokenProvisionResponse } from '../messages';
import { IOperation, ISchemaObject, Item, ItemPath, SchemaObject, SchemaObjectHeader } from '@augloop/types-core';
import { IClientMetadata } from '@augloop/schemas';
import { ISerializedNode } from '@augloop/types-debug';

export class Message implements IMessage {
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IMessage) {
        SchemaObject.assign(Message, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_Message';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Message.getTypeName(), B_: Message.getBaseTypes() };
}

export class Response implements IResponse {
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IResponse) {
        SchemaObject.assign(Response, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_Response';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Response.getTypeName(), B_: Response.getBaseTypes() };
}

export class ErrorResponse implements IErrorResponse {
    public readonly error: string;
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IErrorResponse) {
        SchemaObject.assign(ErrorResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_ErrorResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: ErrorResponse.getTypeName(), B_: ErrorResponse.getBaseTypes() };
}

export class TimeoutErrorResponse implements ITimeoutErrorResponse {
    public readonly error: string;
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITimeoutErrorResponse) {
        SchemaObject.assign(TimeoutErrorResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_TimeoutErrorResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_ErrorResponse', 'AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: TimeoutErrorResponse.getTypeName(), B_: TimeoutErrorResponse.getBaseTypes() };
}

export class SessionInitMessage implements ISessionInitMessage {
    public readonly protocolVersion: number;
    public readonly clientMetadata: IClientMetadata;
    public readonly sessionKey?: string;
    public readonly origin?: string;
    public readonly authToken?: string;
    public readonly extensionConfigs?: ISchemaObject[];
    public readonly returnWorkflowInputTypes?: boolean;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISessionInitMessage) {
        SchemaObject.assign(SessionInitMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_SessionInitMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: SessionInitMessage.getTypeName(), B_: SessionInitMessage.getBaseTypes() };
}

export class SessionInitResponse implements ISessionInitResponse {
    public readonly sessionKey: string;
    public readonly sessionUrlBase: string;
    public readonly origin: string;
    public sliceUrl?: string;
    public forceReconnect?: boolean;
    public tokenExpirationTime?: number;
    public tokenExpirationSeconds?: number;
    public anonymousToken?: string;
    public workflowInputTypes?: string[];
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISessionInitResponse) {
        SchemaObject.assign(SessionInitResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_SessionInitResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: SessionInitResponse.getTypeName(), B_: SessionInitResponse.getBaseTypes() };
}

export class SessionCloseMessage implements ISessionCloseMessage {
    public readonly reconnectAllowed?: boolean;
    public readonly reason?: ISchemaObject;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISessionCloseMessage) {
        SchemaObject.assign(SessionCloseMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_SessionCloseMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: SessionCloseMessage.getTypeName(), B_: SessionCloseMessage.getBaseTypes() };
}

export class CacheDumpRequestMessage implements ICacheDumpRequestMessage {
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ICacheDumpRequestMessage) {
        SchemaObject.assign(CacheDumpRequestMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_CacheDumpRequestMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: CacheDumpRequestMessage.getTypeName(), B_: CacheDumpRequestMessage.getBaseTypes() };
}

export class CacheDumpRequestResponse implements ICacheDumpRequestResponse {
    public readonly serializedNodes: ISerializedNode[];
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ICacheDumpRequestResponse) {
        SchemaObject.assign(CacheDumpRequestResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_CacheDumpRequestResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: CacheDumpRequestResponse.getTypeName(), B_: CacheDumpRequestResponse.getBaseTypes() };
}

export class AnnotationActivationMessage implements IAnnotationActivationMessage {
    public readonly annotationType: string;
    public readonly token: string;
    public readonly batchId?: string;
    public readonly config?: ISchemaObject;
    public readonly ignoreExistingAnnotations?: boolean;
    public readonly sendStateUpdates?: boolean;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAnnotationActivationMessage) {
        SchemaObject.assign(AnnotationActivationMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_AnnotationActivationMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: AnnotationActivationMessage.getTypeName(), B_: AnnotationActivationMessage.getBaseTypes() };
}

export class AnnotationActivationResponse implements IAnnotationActivationResponse {
    public readonly token: string;
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAnnotationActivationResponse) {
        SchemaObject.assign(AnnotationActivationResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_AnnotationActivationResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: AnnotationActivationResponse.getTypeName(), B_: AnnotationActivationResponse.getBaseTypes() };
}

export class AnnotationResultStateMessage implements IAnnotationResultStateMessage {
    public readonly updates: AnnotationResultStateUpdate[];
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAnnotationResultStateMessage) {
        SchemaObject.assign(AnnotationResultStateMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_AnnotationResultStateMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: AnnotationResultStateMessage.getTypeName(), B_: AnnotationResultStateMessage.getBaseTypes() };
}

export class AnnotationReleaseMessage implements IAnnotationReleaseMessage {
    public readonly token: string;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAnnotationReleaseMessage) {
        SchemaObject.assign(AnnotationReleaseMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_AnnotationReleaseMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: AnnotationReleaseMessage.getTypeName(), B_: AnnotationReleaseMessage.getBaseTypes() };
}

export class AnnotationReleaseResponse implements IAnnotationReleaseResponse {
    public readonly lastRelease: boolean;
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAnnotationReleaseResponse) {
        SchemaObject.assign(AnnotationReleaseResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_AnnotationReleaseResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: AnnotationReleaseResponse.getTypeName(), B_: AnnotationReleaseResponse.getBaseTypes() };
}

export class SyncMessage implements ISyncMessage {
    public readonly seq?: number;
    public readonly ops: IOperation[];
    public readonly batchId?: string;
    public groupId?: string;
    public readonly batchComplete?: boolean;
    public groupComplete?: boolean;
    public readonly batchSize?: number;
    public groupSize?: number;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISyncMessage) {
        SchemaObject.assign(SyncMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_SyncMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: SyncMessage.getTypeName(), B_: SyncMessage.getBaseTypes() };
}

export class MicroSyncMessage implements IMicroSyncMessage {
    public readonly item: Item;
    public readonly seq?: number;
    public readonly opType?: string;
    public readonly parentPath?: ItemPath;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IMicroSyncMessage) {
        SchemaObject.assign(MicroSyncMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_MicroSyncMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: MicroSyncMessage.getTypeName(), B_: MicroSyncMessage.getBaseTypes() };
}

export class SyncResponse implements ISyncResponse {
    public readonly minimumSyncIntervalMs?: number;
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISyncResponse) {
        SchemaObject.assign(SyncResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_SyncResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: SyncResponse.getTypeName(), B_: SyncResponse.getBaseTypes() };
}

export class SessionDeleteMessage implements ISessionDeleteMessage {
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISessionDeleteMessage) {
        SchemaObject.assign(SessionDeleteMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_SessionDeleteMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: SessionDeleteMessage.getTypeName(), B_: SessionDeleteMessage.getBaseTypes() };
}

export class AnnotationResultsMessage implements IAnnotationResultsMessage {
    public readonly annotationType: string;
    public readonly seq?: number;
    public readonly ops: IOperation[];
    public readonly batchId?: string;
    public groupId?: string;
    public readonly batchComplete?: boolean;
    public groupComplete?: boolean;
    public readonly batchSize?: number;
    public groupSize?: number;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAnnotationResultsMessage) {
        SchemaObject.assign(AnnotationResultsMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_AnnotationResultsMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_SyncMessage', 'AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: AnnotationResultsMessage.getTypeName(), B_: AnnotationResultsMessage.getBaseTypes() };
}

export class TokenProvisionMessage implements ITokenProvisionMessage {
    public readonly authToken?: string;
    public messageId?: string;
    public cv?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITokenProvisionMessage) {
        SchemaObject.assign(TokenProvisionMessage, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_TokenProvisionMessage';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Message'];
    }
    public static readonly H_ = { T_: TokenProvisionMessage.getTypeName(), B_: TokenProvisionMessage.getBaseTypes() };
}

export class TokenProvisionResponse implements ITokenProvisionResponse {
    public readonly tokenExpirationTime?: number;
    public readonly tokenExpirationSeconds?: number;
    public messageId?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITokenProvisionResponse) {
        SchemaObject.assign(TokenProvisionResponse, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Session_Protocol_TokenProvisionResponse';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Session_Protocol_Response'];
    }
    public static readonly H_ = { T_: TokenProvisionResponse.getTypeName(), B_: TokenProvisionResponse.getBaseTypes() };
}

